function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteEnd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15,0C6.73,0,0,6.73,0,15s6.73,15,15,15,15-6.73,15-15S23.27,0,15,0Zm0,28c-7.17,0-13-5.83-13-13S7.83,2,15,2s13,5.83,13,13-5.83,13-13,13Z",
    style: {
      fill: "#007bfe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.86,14.45c.72.23,1.28.61,1.69,1.15.41.53.61,1.18.61,1.96,0,1.1-.43,1.96-1.3,2.56-.85.59-2.1.88-3.74.88h-6.52v-12.6h6.16c1.54,0,2.71.29,3.53.88.83.59,1.24,1.39,1.24,2.39,0,.61-.15,1.16-.45,1.64-.29.48-.7.86-1.22,1.13Zm-6.35-3.85v2.97h2.9c.72,0,1.27-.13,1.64-.38.37-.25.56-.62.56-1.12s-.19-.86-.56-1.1c-.37-.25-.92-.38-1.64-.38h-2.9Zm3.4,8.21c.77,0,1.34-.13,1.73-.38.4-.25.59-.64.59-1.17,0-1.04-.77-1.57-2.32-1.57h-3.4v3.11h3.4Z",
    style: {
      fill: "#007bfe",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteEnd);
export default __webpack_public_path__ + "static/media/icon-route-end.b1fbaff9fc3fde0c00787a49711f9b56.svg";
export { ForwardRef as ReactComponent };